<template>
  <v-container fluid>
    <Breadcrumbs :history="history" />
    <v-data-table
      :headers="headers"
      :items="purchaseLimits"
      class="elevation-1"
      :loading="isLoading"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="PurchaseLimit-button-new"
            @click="$router.push({
              name: 'shop-EditPurchaseLimit'
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.customerId="{ item }">
        <span v-if="item.customerId">{{ item.customerId }}</span>
        <span v-else>All Customers</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons :editLink="{
            name: 'shop-EditPurchaseLimit',
            query: {id: item.id}
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListPurchaseLimit',
  module: 'Shop',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
      history: [{
        text: 'Home',
        disabled: false,
        href: '/#/members',
        depth: 0,
      }, {
        text: 'Purchase Limits',
        disabled: true,
        depth: 0,
      }],
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('purchaseLimits', ['purchaseLimits']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('customerId'),
          value: 'customerId',
        },
        {
          text: this.$$t('itemCode'),
          value: 'itemCode',
        },
        {
          text: this.$$t('limit'),
          value: 'limit',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_purchaseLimits();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('purchaseLimits', ['LOAD_purchaseLimits', 'DELETE_purchaseLimit']),
    /** Delete PurchaseLimit from the collection
     */
    async remove(purchaseLimit) {
      this.isLoading = true;
      await this.DELETE_purchaseLimit(purchaseLimit.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# PurchaseLimit example

'''js
<PurchaseLimit />
'''
</docs>
